import { render, staticRenderFns } from "./BMPLoadingMobile.vue?vue&type=template&id=21ebad2e&scoped=true"
import script from "./BMPLoadingMobile.vue?vue&type=script&lang=js"
export * from "./BMPLoadingMobile.vue?vue&type=script&lang=js"
import style0 from "./BMPLoadingMobile.vue?vue&type=style&index=0&id=21ebad2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ebad2e",
  null
  
)

export default component.exports